/**
 * Configuration des raccourcis disponibles
 */
export const SHORTCUTS_CONFIG = [
  {
    id: "mes-factures",
    label: "Mes factures",
    icon: "mes_factures.svg",
    tab: "factures",
  },
  {
    id: "mes-commandes",
    label: "Mes commandes",
    icon: "mes_commandes.svg",
    tab: "commandes",
  },
  // {
  //   id: "mes-statistiques",
  //   label: "Mes statistiques",
  //   icon: "mes_stats.svg",
  //   tab: "tableau_bord",
  // },
  {
    id: "mes-contacts",
    label: "Mes contacts",
    icon: "contact.svg",
    tab: "mes_contacts",
  },
  {
    id: "mes-documents",
    label: "Mes documents",
    icon: "documents.svg",
    tab: "documents",
  },
  {
    id: "mes-adresses-livraison",
    label: "Mes adresses de livraison",
    icon: "adresse-livraison.svg",
    tab: "adresse_livraison",
  },
  {
    id: "calcul-ration",
    label: "Calcul de ration",
    icon: "calucl-ration.svg",
    tab: "calcul_ration",
  },
];
